import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, ViewChildren, ViewContainerRef, QueryList, HostListener, NgZone } from '@angular/core';
import { BaseComponent } from '../base-component';
import { EventService } from '../service/event.service';
import { Router } from '@angular/router';
import { CriminalHistoryService } from '../service/criminalhistory.service';
import { AFCriminalHistoryDomain, RadioGroupButtonModel } from '../model/af.model';
import { AbstractControl, FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ChangeNavigationEvent, ProgressBarEvent, ValidateAndNavigateEvent, ShowErrorEvent, ShowProgressEvent, SkipToMainContentEvent } from '../service/events';
import { AuthService } from '../service/auth.service';
import { KeyValue } from '@angular/common';
import { MatRadioChange } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomValidatorsService } from '../service/custom-validators.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';
import { MatSelectionListChange } from '@angular/material/list';

@Component({
  selector: 'app-criminal-history',
  templateUrl: './criminal-history.component.html',
  styleUrls: ['./criminal-history.component.scss'],
  standalone: false
})
export class CriminalHistoryComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  criminalHistoryData: AFCriminalHistoryDomain;
  criminalHistoryForm: UntypedFormGroup;
  maxDate = new Date();
  minDate = new Date(1900, 0, 1);
  step: number = 0;
  sticky: boolean = false;
  menuPosition: any;
  showOffenseList: boolean = false;
  containerWidth: number;
  containerOffsetTop: number;
  hasBeenSubmittted: boolean = false;
  windowScrollAnchor: number = 548; //default without Applicant history
  criminalChange: boolean = false;
  border: boolean = false;
  listCheck: boolean = false;
  radioButtonGroupData: RadioGroupButtonModel[] = [];
  showRadioJudgment: boolean = false;
  showRadioNMLS: boolean = false;
  showRadioAwaitingTrial: boolean = false;
  showRadioPendingCharges: boolean = false;
  showRadioConvicted: boolean = false;
  showRadioDisposition: boolean = false;
  showRadioInvestigation: boolean = false;
  showRadioRespondent: boolean = false;

  @ViewChild("stickyDiv") stickyDivElement: ElementRef;
  @ViewChildren('stickyDiv', { read: ViewContainerRef }) viewContainerRefs: QueryList<any>;
  @ViewChild("addElement") addElement: ElementRef;
  @ViewChild("addButtonElement") addButtonElement: ElementRef;
  @ViewChild("autosize") autosize: CdkTextareaAutosize;
  questions_Category: Array<string> = [];

  constructor(private userService: AuthService, private eventBus: EventService, private criminalHistoryService: CriminalHistoryService, private fb: UntypedFormBuilder,
    private _router: Router, private _snackBar: MatSnackBar, private customValidator: CustomValidatorsService,
    private _ngZone: NgZone) {
    super(eventBus, _router)
  }

  get submit() { return this.criminalHistoryForm.get('submit') }
  get verifyId() { return this.criminalHistoryForm.get('verifyId') }
  get bookmarkUrl() { return this.criminalHistoryForm.get('bookmarkUrl') }

  //flags
  get creditAssignedFlag() { return this.criminalHistoryForm.get('creditAssignedFlag') }
  get safeRegistrationFlag() { return this.criminalHistoryForm.get('safeRegistrationFlag') }
  get awaitTrialFlag() { return this.criminalHistoryForm.get('awaitTrialFlag') }
  get pendingChargesFlag() { return this.criminalHistoryForm.get('pendingChargesFlag') }
  get convictedOffenseFlag() { return this.criminalHistoryForm.get('convictedOffenseFlag') }
  get dispositionAdjudicationFlag() { return this.criminalHistoryForm.get('dispositionAdjudicationFlag') }
  get subjectInvestigationFlag() { return this.criminalHistoryForm.get('subjectInvestigationFlag') }
  get respondentFinancialFlag() { return this.criminalHistoryForm.get('respondentFinancialFlag') }

  get usCriminalNMLSNumber() { return this.criminalHistoryForm.get('usCriminalNMLSNumber') }
  get usCriminalUnsatisfiedComments() { return this.criminalHistoryForm.get('usCriminalUnsatisfiedComments') }
  get usCriminalCreditAssigned() { return this.criminalHistoryForm.get('usCriminalCreditAssigned') }
  get usCriminalSafeRegistration() { return this.criminalHistoryForm.get('usCriminalSafeRegistration') }
  get usCriminalAwaitTrial() { return this.criminalHistoryForm.get('usCriminalAwaitTrial') }
  get usCriminalPending() { return this.criminalHistoryForm.get('usCriminalPending') }
  get usCriminalConvictions() { return this.criminalHistoryForm.get('usCriminalConvictions') }
  get usCriminalDispositions() { return this.criminalHistoryForm.get('usCriminalDispositions') }
  get usCriminalSubjectInvestigation() { return this.criminalHistoryForm.get('usCriminalSubjectInvestigation') }
  get usCriminalSubjectInvestigationComments() { return this.criminalHistoryForm.get('usCriminalSubjectInvestigationComments') }
  get usCriminalRespondentFinancial() { return this.criminalHistoryForm.get('usCriminalRespondentFinancial') }
  get usCriminalRespondentFinancialComments() { return this.criminalHistoryForm.get('usCriminalRespondentFinancialComments') }


  get swapsDisciplinaryAction() { return this.criminalHistoryForm.get('swapsDisciplinaryAction') }
  get swapsDisciplinaryActionDetails() { return this.criminalHistoryForm.get('swapsDisciplinaryActionDetails') }
  get swapsRevocation() { return this.criminalHistoryForm.get('swapsRevocation') }
  get swapsRevocationDetails() { return this.criminalHistoryForm.get('swapsRevocationDetails') }
  get swapsInjunction() { return this.criminalHistoryForm.get('swapsInjunction') }
  get swapsInjunctionDetails() { return this.criminalHistoryForm.get('swapsInjunctionDetails') }
  get swapsRecordofArrest() { return this.criminalHistoryForm.get('swapsRecordofArrest') }
  get swapsRecordofArrestDetails() { return this.criminalHistoryForm.get('swapsRecordofArrestDetails') }



  get criminalOffenseList() { return this.criminalHistoryForm.get('criminalOffenseList') as UntypedFormArray; }
  get afCountryQuestionsList() { return this.criminalHistoryForm.get('afCountryQuestionsList') as UntypedFormArray; }

  ngOnInit() {
    this.subscribeEvents();
    this.createGroup();
  }

  ngAfterViewInit() {
    this.handleZoom();

    this.viewContainerRefs.changes.subscribe(() => {
      if (this.viewContainerRefs.toArray().length) {
        if (this.stickyDivElement) {
          this.containerWidth = this.stickyDivElement.nativeElement.clientWidth;
          this.containerOffsetTop = this.stickyDivElement.nativeElement.offsetTop;
        }
      }
    });

    this.criminalHistoryForm.valueChanges.subscribe(() => {
      this.showOffenses();
      setTimeout(() => {
        let progress = this.getPercentage(this.criminalHistoryForm);
        this.eventBus.emit(new ProgressBarEvent({ id: progress }));
      }, 100);

      if (this.criminalOffenseList.length != 0) {
        this.listCheck = true;
      } else {
        this.listCheck = false;
      }

      if (!this.showOffenseList && this.criminalOffenseList.length > 0) {
        this.criminalOffenseList.clear();
      }

    });

    // retain navigation on page refresh
    let navlink = this.userService.getNavLinks().find(e => e.routerLink === "/criminalHistory");
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));
  }

  onAddCriminalHistory() {
    setTimeout(() => {
      this.addElement.nativeElement.focus();
      this.border = true;
    });
    this.createComponent();
  }

  getPercentage(criminalHistoryForm: UntypedFormGroup): number {
    let errorCount = 0;
    let totalCount = 0;
    let container: UntypedFormGroup = criminalHistoryForm;

    let channelArray: Array<string> = this.nonRequiredFields();

    for (let controlKey in container.controls) {
      if (channelArray.some(x => x === controlKey)) {
        continue;
      }
      if (container.controls.hasOwnProperty(controlKey)) {
        if (container.controls[controlKey].validator != null) {
          totalCount += container.controls[controlKey].validator.length;
        }
        if (container.controls[controlKey].errors) {
          errorCount += Object.keys(container.controls[controlKey].errors).length;
        }
      }
    }

    if (this.hasCriminalHistory()) {
      for (let container of criminalHistoryForm.get('criminalOffenseList')['controls']) {
        for (let controlKey in container.controls) {

          if (container.controls.hasOwnProperty(controlKey)) {
            if (container.controls[controlKey].validator != null) {
              totalCount += container.controls[controlKey].validator.length;
            }
            if (container.controls[controlKey].errors) {
              errorCount += Object.keys(container.controls[controlKey].errors).length;
            }
          }
        }
      }
    }

    let percentage = ((totalCount - errorCount) / totalCount) * 100;
    return percentage;
  }

  setStep(index: number) {
    this.step = index;
  }

  subscribeEvents() {
    this.criminalHistoryService.getCriminalHistory(false).subscribe({
      next: (data: AFCriminalHistoryDomain) => {
        this.criminalHistoryData = data;
        this.populateCriminalHistory();
        if (this.creditAssignedFlag.value != null && Number(this.creditAssignedFlag.value) == -1) {
          this.usCriminalUnsatisfiedComments.setValidators(null); this.usCriminalUnsatisfiedComments.setErrors(null);
          this.usCriminalCreditAssigned.setValidators(null); this.usCriminalCreditAssigned.setErrors(null);
          this.windowScrollAnchor = 800
        }
        if (this.safeRegistrationFlag.value != null && Number(this.safeRegistrationFlag.value) == -1) {
          this.usCriminalNMLSNumber.setValidators(null); this.usCriminalNMLSNumber.setErrors(null);
          this.usCriminalSafeRegistration.setValidators(null); this.usCriminalSafeRegistration.setErrors(null);
          this.windowScrollAnchor = 800
        }


        if (!this.isSwapsAp()) {
          this.swapsDisciplinaryAction.setValidators(null); this.swapsDisciplinaryAction.setErrors(null);
          this.swapsRevocation.setValidators(null); this.swapsRevocation.setErrors(null);
          this.swapsInjunction.setValidators(null); this.swapsInjunction.setErrors(null);
          this.swapsRecordofArrest.setValidators(null); this.swapsRecordofArrest.setErrors(null);
          this.swapsDisciplinaryActionDetails.setValidators(null); this.swapsDisciplinaryActionDetails.setErrors(null);
          this.swapsInjunctionDetails.setValidators(null); this.swapsInjunctionDetails.setErrors(null);
          this.swapsRevocationDetails.setValidators(null); this.swapsRevocationDetails.setErrors(null);
          this.swapsRecordofArrestDetails.setValidators(null); this.swapsRecordofArrestDetails.setErrors(null);

          this.swapsDisciplinaryAction.updateValueAndValidity();
          this.swapsRevocation.updateValueAndValidity();
          this.swapsInjunction.updateValueAndValidity();
          this.swapsRecordofArrest.updateValueAndValidity();
          this.swapsDisciplinaryActionDetails.updateValueAndValidity();
          this.swapsInjunctionDetails.updateValueAndValidity();
          this.swapsRevocationDetails.updateValueAndValidity();
          this.swapsRecordofArrestDetails.updateValueAndValidity();

        }

        /*
          radio button meta data
        */
        //Judgment
        let radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioJudgement";
        if (data.creditAssignedFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalCreditAssigned;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);
        //NMLS
        radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioNMLS";
        if (data.safeRegistrationFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalSafeRegistration;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);
        //AwaitingTrial
        radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioAwaitTrial";
        if (data.awaitTrialFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalAwaitTrial;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);
        //PendingCharges
        radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioPendingCharges";
        if (data.pendingChargesFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalPending;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);
        //Convicted
        radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioConvicted";
        if (data.convictedOffenseFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalConvictions;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);
        //Disposition
        radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioDisposition";
        if (data.dispositionAdjudicationFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalDispositions;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);
        //Investigation
        radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioInvestigation";
        if (data.subjectInvestigationFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalSubjectInvestigation;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);
        //Respondent
        radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioRespondent";
        if (data.respondentFinancialFlag != "-1") {
          radioGroupMetaData.groupValue = data.usCriminalRespondentFinancial;
        }
        this.radioButtonGroupData.push(radioGroupMetaData);

        //if flag is set, set validation for comments. else set validators to null
        if (this.subjectInvestigationFlag.value != null && Number(this.subjectInvestigationFlag.value != -1)) {
          this.setusCriminalRadioSubjectInvestigationExpln(this.usCriminalSubjectInvestigation.value, this.usCriminalSubjectInvestigationComments);

          this.usCriminalSubjectInvestigation.valueChanges
            .subscribe(() => {
              this.setusCriminalRadioSubjectInvestigationExpln(this.usCriminalSubjectInvestigation.value, this.usCriminalSubjectInvestigationComments);
            });
        } else {
          this.usCriminalSubjectInvestigation.setValidators(null);
          this.usCriminalSubjectInvestigation.setErrors(null);
          this.usCriminalSubjectInvestigationComments.setValidators(null);
          this.usCriminalSubjectInvestigationComments.setErrors(null);
        }

        //if flag is set, set validation for comments. else set validators to null
        if (this.respondentFinancialFlag.value != null && Number(this.respondentFinancialFlag.value != -1)) {
          this.setusCriminalRadioSubjectInvestigationExpln(this.usCriminalRespondentFinancial.value, this.usCriminalRespondentFinancialComments);

          this.usCriminalRespondentFinancial.valueChanges
            .subscribe(() => {
              this.setusCriminalRadioSubjectInvestigationExpln(this.usCriminalRespondentFinancial.value, this.usCriminalRespondentFinancialComments);
            });
        } else {
          this.usCriminalRespondentFinancial.setValidators(null);
          this.usCriminalRespondentFinancial.setErrors(null);
          this.usCriminalRespondentFinancialComments.setValidators(null);
          this.usCriminalRespondentFinancialComments.setErrors(null);
        }
      },
      error: (error: Error) => {
        console.log(error);
      }
    });

    this.sub = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        if (event.payload.currentLink === '/criminalHistory') {
          this.submit.setValue(false);
          this.bookmarkUrl.setValue("");
          if (event.payload.save) {
            this.submitCriminalHistory((this.criminalHistoryForm.value), event);
          } else if (event.payload.saveAndFinishLater) {
            this.bookmarkUrl.setValue(event.payload.currentLink);
            this.submitCriminalHistory((this.criminalHistoryForm.value), event);
          } else {
            let hasCriminalHistory: boolean = this.hasCriminalHistory();
            if (hasCriminalHistory) {
              if (this.criminalOffenseList.length > 0) {
                this.criminalOffenseList.markAllAsTouched();
              } else {
                this.createComponent();
                this.focusTarget();
              }
              this.eventBus.emit(new ShowProgressEvent({ show: false }));
              this.eventBus.emit(new ShowErrorEvent({ httpStatus: 500, text: 'At least one Offense/Regulatory Action Details is Required.' }));
            } else if (this.validate()) {
              this.submitCriminalHistory((this.criminalHistoryForm.value), event);
            }
          }
        }
      }
    );

    this.eventBus.on(
      SkipToMainContentEvent,
      (event): void => {
        if (event.payload.text && event.payload.text == "/criminalHistory") {
          let mainContentElement = document.querySelector("#main-content"); //check if main-content id exists on page
          if (mainContentElement) {
            mainContentElement.scrollIntoView(true);
          }
        }
      }
    );
  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  radioOnChange(event: MatRadioChange) {
    const radioGroupName = event.source.name;
    const radioGroupChgValue = event.value;
    if (this.radioButtonGroupData) {
      for (let radioGroup of this.radioButtonGroupData) {
        if (radioGroup.groupName == radioGroupName) {
          radioGroup.groupValue = radioGroupChgValue;
          break;
        }
      }
    }
  }

  radioOnFocusOut(event: any) {
    const radioGroupName = event.target.name;
    let showError: boolean = false;
    if (this.radioButtonGroupData) {
      for (let radioGroup of this.radioButtonGroupData) {
        if (radioGroup.groupName == radioGroupName) {
          if (radioGroup.groupValue != "0" && radioGroup.groupValue != "1") {
            showError = true;
          }

          if (radioGroup.groupName == "radioJudgement") {
            this.showRadioJudgment = showError;
          }
          else if (radioGroup.groupName == "radioNMLS") {
            this.showRadioNMLS = showError;
          }
          else if (radioGroup.groupName == "radioAwaitTrial") {
            this.showRadioAwaitingTrial = showError;
          }
          else if (radioGroup.groupName == "radioPendingCharges") {
            this.showRadioPendingCharges = showError;
          }
          else if (radioGroup.groupName == "radioConvicted") {
            this.showRadioConvicted = showError;
          }
          else if (radioGroup.groupName == "radioDisposition") {
            this.showRadioDisposition = showError;
          }
          else if (radioGroup.groupName == "radioInvestigation") {
            this.showRadioInvestigation = showError;
          }
          else if (radioGroup.groupName == "radioRespondent") {
            this.showRadioRespondent = showError;
          }
          break;
        }
      }
    }
  }

  radioOnFocus(event: any) {
    const radioGroupName = event.target.name;
    if (radioGroupName == "radioJudgement") {
      this.showRadioJudgment = false;
    }
    else if (radioGroupName == "radioNMLS") {
      this.showRadioNMLS = false;
    }
    else if (radioGroupName == "radioAwaitTrial") {
      this.showRadioAwaitingTrial = false;
    }
    else if (radioGroupName == "radioPendingCharges") {
      this.showRadioPendingCharges = false;
    }
    else if (radioGroupName == "radioConvicted") {
      this.showRadioConvicted = false;
    }
    else if (radioGroupName == "radioDisposition") {
      this.showRadioDisposition = false;
    }
    else if (radioGroupName == "radioInvestigation") {
      this.showRadioInvestigation = false;
    }
    else if (radioGroupName == "radioRespondent") {
      this.showRadioRespondent = false;
    }
  }

  populateCriminalHistory() {
    this.criminalHistoryForm.patchValue(this.criminalHistoryData);
    this.showOffenses();

    for (let criminalOffense of this.criminalHistoryData.criminalOffenseList) {
      let fg: UntypedFormGroup = this.fieldsGroup();
      fg.patchValue(criminalOffense);
      this.criminalOffenseList.push(fg);
      this.setValidators(fg);
    }

    if (this.criminalOffenseList.length == 0) {
      if (this.showOffenseList) {
        this.createComponent();
      }
    } else {
      this.criminalOffenseList.markAllAsTouched();
    }

  }

  showOffenses() {
    this.showOffenseList = (this.usCriminalAwaitTrial.value == 1 || this.usCriminalPending.value == 1 || this.usCriminalConvictions.value == 1 ||
      this.usCriminalDispositions.value == 1 || this.usCriminalSubjectInvestigation.value == 1 || this.usCriminalRespondentFinancial.value == 1);
  }

  hasApplicantHistory(): boolean {
    let applicantHistory: boolean = (
      (this.creditAssignedFlag.value != null && Number(this.creditAssignedFlag.value) != -1) ||
      (this.safeRegistrationFlag.value != null && Number(this.safeRegistrationFlag.value) != -1)
    );
    return applicantHistory;
  }

  isSwapsAp(): boolean {
    return this.userService.isSwapsAP();
  }

  hasCriminalHistory(): boolean {
    let criminalHistory: boolean = (this.usCriminalAwaitTrial.value == 1 || this.usCriminalPending.value == 1 || this.usCriminalConvictions.value == 1 ||
      this.usCriminalDispositions.value == 1 || this.usCriminalSubjectInvestigation.value == 1 || this.usCriminalRespondentFinancial.value == 1);

    let hasOffense: boolean = false;
    if (this.criminalOffenseList.length > 0 && this.criminalOffenseList.valid) {
      hasOffense = true;
    }

    return (criminalHistory && !hasOffense);
  }

  nonRequiredFields(): Array<string> {
    let channelArray: Array<string>;
    if ((this.creditAssignedFlag.value != null && Number(this.creditAssignedFlag.value) != -1) &&
      (this.safeRegistrationFlag.value != null && Number(this.safeRegistrationFlag.value) != -1)) {
      channelArray = ['usCriminalNMLSNumber', 'usCriminalUnsatisfiedComments', 'criminalOffenseList', 'submit', 'creditAssignedFlag', 'safeRegistrationFlag', 'awaitTrialFlag', 'pendingChargesFlag', 'convictedOffenseFlag', 'dispositionAdjudicationFlag', 'dispositionAdjudicationFlag', 'subjectInvestigationFlag', 'respondentFinancialFlag'];
    } else if (this.creditAssignedFlag.value != null && Number(this.creditAssignedFlag.value) != -1) {
      channelArray = ['usCriminalSafeRegistration', 'usCriminalNMLSNumber', 'usCriminalUnsatisfiedComments', 'criminalOffenseList', 'submit', 'creditAssignedFlag', 'safeRegistrationFlag', 'awaitTrialFlag', 'pendingChargesFlag', 'convictedOffenseFlag', 'dispositionAdjudicationFlag', 'dispositionAdjudicationFlag', 'subjectInvestigationFlag', 'respondentFinancialFlag'];
    } else if (this.safeRegistrationFlag.value != null && Number(this.safeRegistrationFlag.value) != -1) {
      channelArray = ['usCriminalCreditAssigned', 'usCriminalSafeRegistration', 'usCriminalNMLSNumber', 'usCriminalUnsatisfiedComments', 'criminalOffenseList', 'submit', 'creditAssignedFlag', 'safeRegistrationFlag', 'awaitTrialFlag', 'pendingChargesFlag', 'convictedOffenseFlag', 'dispositionAdjudicationFlag', 'dispositionAdjudicationFlag', 'subjectInvestigationFlag', 'respondentFinancialFlag'];
    } else {
      channelArray = ['usCriminalCreditAssigned', 'usCriminalSafeRegistration', 'usCriminalNMLSNumber', 'usCriminalUnsatisfiedComments', 'criminalOffenseList', 'submit', 'creditAssignedFlag', 'safeRegistrationFlag', 'awaitTrialFlag', 'pendingChargesFlag', 'convictedOffenseFlag', 'dispositionAdjudicationFlag', 'dispositionAdjudicationFlag', 'subjectInvestigationFlag', 'respondentFinancialFlag'];
    }

    return channelArray;
  }

  createComponent() {
    let fg: UntypedFormGroup = this.fieldsGroup();
    this.criminalOffenseList.push(fg);
    this.step = this.criminalOffenseList.length - 1;
    this.submit.setValue(false);
    this.setValidators(fg);
  }

  fieldsGroup(): UntypedFormGroup {
    return this.fb.group({
      offenseOrRegulatoryAction: ['', [Validators.required]],
      othrCmtOffenseType: ['', [Validators.required, Validators.maxLength(50), this.customValidator.validateRequiredField]],
      country: ['186', [Validators.required]],
      dateOfOffense: ['', [Validators.required]],
      explanation: ['', [Validators.required, Validators.maxLength(1000), this.customValidator.validateRequiredField]],
      usState: ['', [Validators.required]],
      county: [''],
      levelOfOffense: ['', [Validators.required]],
      othrCmtLevelOfOffense: ['', [Validators.required, Validators.maxLength(50), this.customValidator.validateRequiredField]],
      cityOrTown: [''],
      stateOrProvince: [''],
      dateOfArrest: [''],
      dateOfDisposition: [''],
      disposition: ['', [Validators.required]],
      othrCmtDisposition: ['', [Validators.required, Validators.maxLength(100), this.customValidator.validateRequiredField]],
      sentence: ['']
    });
  }

  submitCriminalHistory(criminalHistory, event) {
    this.criminalHistoryService.submitCriminalHistory(criminalHistory).subscribe({
      next: () => {
        if (event.payload.save) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
        } else if (event.payload.saveAndFinishLater) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
          this._router.navigate(['sessionTimedOut']);
        } else {
          this.eventBus.emit(new ChangeNavigationEvent({ id: event.payload.id }));
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      },
      error: (error: any) => console.log(error)
    });
  }

  handleSelection(event: MatSelectionListChange) {
    event.source.deselectAll();
    event.options[0].selected = true;
    this.step = event.options[0].value;
  }

  deleteClick(i) {
    this.criminalOffenseList.removeAt(i);
    if (i == this.criminalOffenseList.length) {
      this.step = i - 1;
    }

    setTimeout(() => {
      if (this.criminalOffenseList && this.criminalOffenseList.length == 0) {
        this.addButtonElement.nativeElement.focus();
        this.border = false;
      } else {
        this.addElement.nativeElement.focus();
        this.border = true;
      }
    });
  }

  focusTarget() {
    setTimeout(() => {
      this.addElement.nativeElement.focus();
      this.border = true;
    });
  }

  @HostListener('document:keydown', ['$event'])
  clearBorder(keyDown: KeyboardEvent) {
    if (keyDown.key === 'Tab') {
      this.border = false;
    }
  }

  @HostListener('click', ['$event'])
  clearBorderClick() {
    this.border = false;
  }

  dropDownScreenReaderCountry(criminal: any): string {
    if (criminal.controls.country.value) {
      return 'Selected ' + this.criminalHistoryData.countryLookup[Object.keys(this.criminalHistoryData.countryLookup).find(e => e === criminal.controls.country.value)];
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderState(criminal: any): string {
    if (criminal.controls.usState.value) {
      return 'Selected ' + this.criminalHistoryData.usStateLookup[Object.keys(this.criminalHistoryData.usStateLookup).find(e => e === criminal.controls.usState.value)];
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderOffense(criminal: any): string {
    if (criminal.controls.offenseOrRegulatoryAction.value) {
      return 'Selected ' + criminal.controls.offenseOrRegulatoryAction.value;
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderOffenseLevel(criminal: any): string {
    if (criminal.controls.levelOfOffense.value) {
      return 'Selected ' + this.criminalHistoryData.offenseLevelLookup[Object.keys(this.criminalHistoryData.offenseLevelLookup).find(e => e === criminal.controls.levelOfOffense.value)];
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderDisposition(criminal: any): string {
    if (criminal.controls.disposition.value) {
      return 'Selected ' + this.criminalHistoryData.dispositionlookup[Object.keys(this.criminalHistoryData.dispositionlookup).find(e => e === criminal.controls.disposition.value)];
    } else {
      return 'blank';
    }
  }

  valueAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value.localeCompare(b.value);
  }

  valueAscOrderOtherLast = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    try {
      if (a.value == "Other") {
        return 1;
      }
      if (b.value == "Other") {
        return -1;
      }
      return a.value.localeCompare(b.value);
    } catch (e) {
      console.log(e);
    }
  }

  idAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    let keyA: number = Number(a.key);
    let keyB: number = Number(b.key);

    if (keyA > keyB) {
      return 1;
    }
    if (keyA < keyB) {
      return -1;
    }
    return 0;
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  handleZoom() {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    if (windowWidth <= 935 || windowHeight <= 650) {
      this.criminalChange = true;
    } else {
      this.criminalChange = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll(offSet: number) {
    const windowScroll = window.pageYOffset;
    let offSetTop = this.containerOffsetTop - 125;

    if (typeof offSet === 'number' && offSet != this.containerOffsetTop) {
      this.containerOffsetTop = offSet; //on textbox resize
    }

    if (windowScroll >= this.windowScrollAnchor && windowScroll > offSetTop) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }

    if (offSetTop === 45) {
      this.containerOffsetTop = this.stickyDivElement.nativeElement.offsetTop;
      this.sticky = false; //reset on form value change
    }
  }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }
  @HostListener('window:resize', ['$event'])
  onResized() {
    if (this.stickyDivElement) {
      this.handleScroll(this.stickyDivElement.nativeElement.offsetTop);
    }
  }



  createGroup() {
    this.criminalHistoryForm = this.fb.group({
      submit: [false],
      verifyId: [this.userService.getVerifyId(), []],
      //flags
      creditAssignedFlag: [''],
      safeRegistrationFlag: [''],
      awaitTrialFlag: [''],
      pendingChargesFlag: [''],
      convictedOffenseFlag: [''],
      dispositionAdjudicationFlag: [''],
      subjectInvestigationFlag: [''],
      respondentFinancialFlag: [''],
      //form controls
      usCriminalNMLSNumber: ['', [Validators.maxLength(150)]],
      usCriminalUnsatisfiedComments: ['', [Validators.maxLength(4000)]],
      usCriminalCreditAssigned: ['', [Validators.required]],
      usCriminalSafeRegistration: ['', [Validators.required]],
      usCriminalAwaitTrial: ['', [Validators.required]],
      usCriminalPending: ['', [Validators.required]],
      usCriminalConvictions: ['', [Validators.required]],
      usCriminalDispositions: ['', [Validators.required]],
      usCriminalSubjectInvestigation: ['', [Validators.required]],
      usCriminalSubjectInvestigationComments: ['', [Validators.required]],
      usCriminalRespondentFinancial: ['', [Validators.required]],
      usCriminalRespondentFinancialComments: ['', [Validators.required]],
      bookmarkUrl: [''],


      swapsDisciplinaryAction: ['', [Validators.required]],
      swapsDisciplinaryActionDetails: ['', [Validators.maxLength(4000)]],

      swapsRevocation: ['', [Validators.required]],
      swapsRevocationDetails: ['', [Validators.maxLength(4000)]],

      swapsInjunction: ['', [Validators.required]],
      swapsInjunctionDetails: ['', [Validators.maxLength(4000)]],

      swapsRecordofArrest: ['', [Validators.required]],
      swapsRecordofArrestDetails: ['', [Validators.maxLength(4000)]],

      criminalOffenseList: new UntypedFormArray([])
    });
  }

  setValidators(control: UntypedFormGroup) {

    const country = control.get('country');
    const usState = control.get('usState');
    this.setStateValidators(country.value, usState);
    country.valueChanges
      .subscribe(country => {
        this.setStateValidators(country, usState);
      });

    const offenseOrRegulatoryAction = control.get('offenseOrRegulatoryAction');
    const othrCmtOffenseType = control.get('othrCmtOffenseType');
    this.setOthrCmtOffenseType(offenseOrRegulatoryAction.value, othrCmtOffenseType);
    offenseOrRegulatoryAction.valueChanges
      .subscribe(offenseOrRegulatoryAction => {
        this.setOthrCmtOffenseType(offenseOrRegulatoryAction, othrCmtOffenseType);
      });

    const levelOfOffense = control.get('levelOfOffense');
    const othrCmtLevelOfOffense = control.get('othrCmtLevelOfOffense');
    this.setOthrCmtLevelOfOffense(levelOfOffense.value, othrCmtLevelOfOffense);
    levelOfOffense.valueChanges
      .subscribe(levelOfOffense => {
        this.setOthrCmtLevelOfOffense(levelOfOffense, othrCmtLevelOfOffense);
      });

    const disposition = control.get('disposition');
    const othrCmtDisposition = control.get('othrCmtDisposition');
    this.setOthrCmtDisposition(disposition.value, othrCmtDisposition);
    disposition.valueChanges
      .subscribe(disposition => {
        this.setOthrCmtDisposition(disposition, othrCmtDisposition);
      });

  }

  setStateValidators(value: string, usState: AbstractControl) {
    if (value === "186") {
      usState.setValidators([Validators.required]);
    } else {
      usState.setValidators(null);
      usState.setErrors(null);
    }
    usState.updateValueAndValidity();
  }

  setOthrCmtOffenseType(value: string, othrCmtOffenseType: AbstractControl) {
    if (value === "Other") {
      othrCmtOffenseType.setValidators([Validators.required, this.customValidator.validateRequiredField]);
    } else {
      othrCmtOffenseType.setValidators(null);
      othrCmtOffenseType.setErrors(null);
    }
    othrCmtOffenseType.updateValueAndValidity();
  }

  setOthrCmtLevelOfOffense(value: string, othrCmtLevelOfOffense: AbstractControl) {
    if (value === "16") {//Other
      othrCmtLevelOfOffense.setValidators([Validators.required, this.customValidator.validateRequiredField]);
    } else {
      othrCmtLevelOfOffense.setValidators(null);
      othrCmtLevelOfOffense.setErrors(null);
    }
    othrCmtLevelOfOffense.updateValueAndValidity();
  }

  setOthrCmtDisposition(value: string, othrCmtDisposition: AbstractControl) {
    if (value === "9") {//Other
      othrCmtDisposition.setValidators([Validators.required, this.customValidator.validateRequiredField]);
    } else {
      othrCmtDisposition.setValidators(null);
      othrCmtDisposition.setErrors(null);
    }
    othrCmtDisposition.updateValueAndValidity();
  }

  setusCriminalRadioSubjectInvestigationExpln(value: string, subInvExpl: AbstractControl) {
    if (value === "1") {

      subInvExpl.setValidators([Validators.required, this.customValidator.validateRequiredField]);
    } else {
      subInvExpl.setValidators(null);
      subInvExpl.setErrors(null);
    }
    subInvExpl.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  validate() {
    this.submit.setValue(true);
    this.hasBeenSubmittted = true;
    this.criminalHistoryForm.markAllAsTouched();
    if (this.criminalHistoryForm?.invalid) {
      let isInvalid = true;
      const firstInvalidField = Object.keys(this.criminalHistoryForm.controls).find(field => this.criminalHistoryForm.get(field)?.invalid);
      if (this.criminalHistoryForm.controls[firstInvalidField] instanceof FormArray) {
        (<FormArray>this.criminalHistoryForm.controls[firstInvalidField]).controls.forEach((data: FormGroup) => {
          if (data.invalid && isInvalid) {
            this.userService.setFocus(data);
            isInvalid = false;
          }
        })
      } else {
        this.userService.setFocus(this.criminalHistoryForm);
      }
    }
    return !this.criminalHistoryForm.invalid;
  }

  countryQuestionsGroup(): UntypedFormGroup {
    return this.fb.group({
      id: [''],
      afId: [''],
      questionId: [''],
      questions: [''],
      answer: [''],
      description: [''],
      category: [''],
      countryCd: [''],
    });
  }
  
  populateCountryQuestions() {
    this.questions_Category = this.criminalHistoryData.afCountryQuestionsList.map(item => item.category).filter((value, index, self) => self.indexOf(value) === index)
    for (let questions of this.criminalHistoryData.afCountryQuestionsList) {
      let fg: UntypedFormGroup = this.countryQuestionsGroup();
      fg.patchValue(questions);
      this.afCountryQuestionsList.push(fg);
    }
  }

  getQuestionsbasedCategory(value: string) {
    return this.afCountryQuestionsList.controls.filter(a => a.value.category.toUpperCase() == value.toUpperCase());
  }
}
